import { render, staticRenderFns } from "./AlcadaCadastro.vue?vue&type=template&id=0b04a82a&lang=html&"
import script from "./AlcadaCadastro.vue?vue&type=script&lang=js&"
export * from "./AlcadaCadastro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/alcada/AlcadaCadastro.vue
// module id = 1023
// module chunks = 28